import { useTranslation } from "react-i18next";
import { WorktimeSchedule } from "../../models/worktimeSchedule";
import { convertTimeStringToUTCHint, getCurrentTimezone } from "../../helpers/dateHelper";
import { useEffect, useState } from "react";

interface TechSupportStatusProps {
  worktimes: WorktimeSchedule | null;
}

const TechSupportWorkSchedule = ({ worktimes }: TechSupportStatusProps) => {
  const { t } = useTranslation();
  const [timeZone, setTimeZone] = useState("");

  // Дни недели в правильном порядке
  const weekDaysOrder = [1, 2, 3, 4, 5, 6, 0]; // пн, вт, ср, чт, пт, сб, вс

  useEffect(() => {
    const timeZone = getCurrentTimezone();
    setTimeZone(timeZone);
  }, []);

  // Функция для получения UTC времени из расписания
  const getUTCTimeText = (start: string, end: string) => {
    if (start === end) return t("Day off");
    const utcStart = convertTimeStringToUTCHint(start);
    const utcEnd = convertTimeStringToUTCHint(end);
    return `${utcStart} - ${utcEnd} UTC`;
  };

  if (!worktimes?.schedules) {
    // Скелетон при загрузке
    return (
      <div className="space-y-2 p-4">
        {weekDaysOrder.map((day) => (
          <div key={day} className="flex items-center">
            <div className="h-5 w-16 bg-gray-200 rounded animate-pulse mr-2"></div>
            <div className="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
          </div>
        ))}
        <div className="h-4 w-full bg-gray-200 rounded animate-pulse mt-2"></div>
      </div>
    );
  }

  // Получаем название дня недели
  const getDayName = (dayIndex: number) => {
    const days = [
      t("Sun"), t("Mon"), t("Tue"), 
      t("Wed"), t("Thu"), t("Fri"), t("Sat")
    ];
    return days[dayIndex];
  };

  return (
    <div className="space-y-1 p-4">
      {weekDaysOrder.map((dayIndex) => {
        const daySchedule = worktimes.schedules.find(s => s.day === dayIndex);
        if (!daySchedule) return null;

        const isDayOff = daySchedule.start === daySchedule.end;
        const timeText = isDayOff 
          ? t("Day off") 
          : `${daySchedule.start} - ${daySchedule.end}`;
        const utcTimeText = getUTCTimeText(daySchedule.start, daySchedule.end);

        return (
          <div key={dayIndex} className="flex items-center">
            <span className="w-16 font-medium">
              {getDayName(dayIndex)}:
            </span>
            <span 
              className={`${isDayOff ? 'text-danger' : 'text-success'} relative group`}
              title={utcTimeText}
            >
              {timeText}              
            </span>
          </div>
        );
      })}
      {timeZone && (
        <div className="text-xs text-gray-500 mt-2">
          {t("Timezone")}: {timeZone}
        </div>
      )}
    </div>
  );
};

export default TechSupportWorkSchedule;